// @flow

export const b64toType = (dataURI: string) => {
  const typeArr = dataURI.split(',')
  const matches = typeArr[0].match(/:(.*?);/)
  if (matches !== null)
    return matches[1]
}

export const b64toBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(',')[1])
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ab], { type: 'image/jpeg' })
}
